import { render, staticRenderFns } from "./office-search-item.vue?vue&type=template&id=0ec9904f&"
import script from "./office-search-item.vue?vue&type=script&lang=js&"
export * from "./office-search-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports